import React from "react";
import {connect} from "react-redux";
import {List} from "immutable";
import ActionButton from "../../components/ActionButton";
import {requestShowSerialNumbers} from "../../actions/SerialNumberActions";

// "40 serials", opening them in a window. Nothing for a line without serials.
const SerialNumbersButton = ({serialNrs, title, requestShowSerialNumbers}) => {
  const serials = List(serialNrs || []).toJS();
  if (serials.length === 0) return null;
  return (
    <ActionButton
      label={`${serials.length} serial${serials.length === 1 ? "" : "s"}`}
      primary={false}
      onClick={() => requestShowSerialNumbers(title, serials)} />
  )
}

export default connect(null, {requestShowSerialNumbers})(SerialNumbersButton);
